import { liveQuerySubscribeLock, LIVE_QUERY_SUBSCRIBE_LOCK_KEY } from 'util/asyncLocks';
import { addTicketToQueue, updateReviewTicketInQueue, removeReviewTicketFromQueue, selectDefaultTicket } from 'actions';
import { extractSelectedTicketIdFromState, isAPartnerProtector, getPartnersAllowlist } from 'extractFromState';
import isEmpty from 'lodash/isEmpty';
import { SHOW_TOOLS } from 'actions/types';
import { getExpertId } from 'util/parseSelectors';
import {
  CONVERSATION_ENTER_SUBSCRIPTION,
  CONVERSATION_UPDATE_SUBSCRIPTION,
  CONVERSATION_LEAVE_SUBSCRIPTION,
} from './conversationSubscriptions.gql';
import subscribeToLiveQuery from '../subscribeToLiveQuery';
import { NOMINATED_FOR_REVIEW } from 'constants/ticketStatuses';

const reviewTicketSubscriptions = [];

const startReviewTicketsQuery = (store) => {
  if (reviewTicketSubscriptions.length === 0 && isAPartnerProtector(store.getState())) {
    liveQuerySubscribeLock.acquire(LIVE_QUERY_SUBSCRIBE_LOCK_KEY, async (lockDoneFunction) => {
      const expertId = getExpertId();
      const partnersAllowlist = getPartnersAllowlist(store.getState());

      const filter = {
        reviewExpertId: {
          eq: expertId,
        },
        reviewStatus: {
          eq: NOMINATED_FOR_REVIEW,
        },
      };

      if (!isEmpty(partnersAllowlist)) {
        filter.and = [{ simplrAccountId: { in: [...partnersAllowlist] } }];
      }

      const variables = {
        filter,
      };

      const handleOnEnter = (conversation) => {
        store.dispatch(addTicketToQueue({ conversation, queueName: 'review' }));
      };

      const handleOnUpdate = (conversation) => {
        store.dispatch(updateReviewTicketInQueue(conversation));
      };

      const handleOnLeave = (conversation) => {
        store.dispatch(removeReviewTicketFromQueue(conversation.id, 'review'));
        const selectedTicketId = extractSelectedTicketIdFromState(store.getState());
        if (selectedTicketId && selectedTicketId === conversation.id) {
          store.dispatch({ type: SHOW_TOOLS, value: false });
          store.dispatch(selectDefaultTicket());
        }
      };

      const createSubscription = subscribeToLiveQuery(
        CONVERSATION_ENTER_SUBSCRIPTION,
        variables,
        'onEnterConversation',
        handleOnEnter
      );

      const updateSubscription = subscribeToLiveQuery(
        CONVERSATION_UPDATE_SUBSCRIPTION,
        variables,
        'onUpdateConversation',
        handleOnUpdate
      );

      const leaveSubscription = subscribeToLiveQuery(
        CONVERSATION_LEAVE_SUBSCRIPTION,
        variables,
        'onLeaveConversation',
        handleOnLeave
      );

      reviewTicketSubscriptions.push(createSubscription, updateSubscription, leaveSubscription);

      lockDoneFunction();
    });
  }
};

export { startReviewTicketsQuery };
